import React from "react";
import { useNavigate } from "react-router-dom";
import "./MainService.css";

const ServiceItem = ({ title, services }) => {
  const navigate = useNavigate();
  const handleNavigate = (url) => {
    navigate('/' + url);
  }

  return (
    <section className="services-section">
      <h2 className="section-title">{title}</h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-item" onClick={() => handleNavigate(service.url)}>
            <img src={service.image} alt={service.title} className="service-image" />
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceItem;
